
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/owner/dashboard",
      function () {
        return require("private-next-pages/owner/dashboard.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/owner/dashboard"])
      });
    }
  